import React from "react";
import styled from "styled-components";

export const BookingInvoiceSection = ({
  bookingRoomInvoice,
  bookingRoomRefunds,
}) => {
  const handleDownload = (url, filename) => {
    if (!url) return;
    const link = document.createElement("a");
    link.href = url;
    link.download = filename || "document.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Container>
      {/* Invoices Section */}
      {bookingRoomInvoice && bookingRoomInvoice.length > 0 && (
        <Card>
          <SectionTitle>Invoices ({bookingRoomInvoice.length})</SectionTitle>

          {bookingRoomInvoice.map((invoice, index) => (
            <InvoiceItem key={invoice.id}>
              <InvoiceInfo>
                <Label>Invoice {index + 1}</Label>
                <Value>₹{invoice.invoice_amount}</Value>
                <SmallDetail>GST: ₹{invoice.gst_amount}</SmallDetail>
                {invoice.invoice_number && (
                  <SmallDetail>
                    Invoice No: {invoice.invoice_number}
                  </SmallDetail>
                )}
                <SmallText>
                  {new Date(invoice.created_at).toLocaleDateString("en-IN")}
                </SmallText>
              </InvoiceInfo>

              <DownloadButton
                onClick={() =>
                  handleDownload(
                    invoice.invoice_url,
                    `Invoice_${invoice.booking_id}_${invoice.id}.pdf`,
                  )
                }
              >
                Download Invoice
              </DownloadButton>
            </InvoiceItem>
          ))}
        </Card>
      )}

      {/* Refunds Section */}
      {bookingRoomRefunds && bookingRoomRefunds.length > 0 && (
        <Card>
          <SectionTitle>Refunds ({bookingRoomRefunds.length})</SectionTitle>

          {bookingRoomRefunds.map((refund, index) => (
            <RefundItem key={refund.id}>
              <RefundInfo>
                <Label>Refund {index + 1}</Label>
                <Value>
                  ₹{refund.refund_amount} (GST: ₹{refund.gst_amount})
                </Value>
                <Reason>{refund.reason}</Reason>
                <SmallText>
                  {new Date(refund.created_at).toLocaleDateString("en-IN")}
                </SmallText>
              </RefundInfo>

              <DownloadButton
                onClick={() =>
                  handleDownload(
                    refund.refund_invoice_url,
                    `Refund_${refund.booking_id}_${refund.id}.pdf`,
                  )
                }
              >
                Download Refund Invoice
              </DownloadButton>
            </RefundItem>
          ))}
        </Card>
      )}
    </Container>
  );
};

// ==================== Styled Components ====================

const Container = styled.div`
  padding: 20px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;

  @media (min-width: 768px) {
    padding: 30px 40px;
  }
`;

const Card = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
`;

const SectionTitle = styled.h3`
  font-family: openSans-SemiBold, sans-serif;
  font-size: 16px;
  color: #293461;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f3f4f6;
`;

const InvoiceItem = styled.div`
  padding: 16px 0;
  border-bottom: 1px solid #f3f4f6;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const RefundItem = styled(InvoiceItem)``; // Reuse same styling

const InvoiceInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

const RefundInfo = styled(InvoiceInfo)``; // Reuse same styling

const Label = styled.div`
  font-family: openSans-SemiBold, sans-serif;
  font-size: 13px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
`;

const Value = styled.div`
  font-family: openSans-SemiBold, sans-serif;
  font-size: 15px;
  color: #293461;
  margin-bottom: 6px;
`;

const SmallDetail = styled.div`
  font-size: 13.5px;
  color: #4b5563;
  margin-bottom: 4px;
`;

const Reason = styled.div`
  font-size: 14px;
  color: #4b5563;
  margin-top: 6px;
  font-style: italic;
  line-height: 1.5;
`;

const SmallText = styled.div`
  font-size: 12px;
  color: #9ca3af;
  margin-top: 6px;
`;

const DownloadButton = styled.button`
  background: #00838c;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-family: openSans-SemiBold, sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  height: fit-content;
  margin-top: 4px;

  &:hover {
    background: #00838c;
    transform: translateY(-1px);
  }
`;
